var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Figma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#f1edd5",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26,17h-8c-3.866,0 -7,-3.134 -7,-7v0c0,-3.866 3.134,-7 7,-7h8z",
    fill: "#e64a19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,31h-7c-3.866,0 -7,-3.134 -7,-7v0c0,-3.866 3.134,-7 7,-7h7z",
    fill: "#7c4dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,45v0c-3.866,0 -7,-3.134 -7,-7v0c0,-3.866 3.134,-7 7,-7h7v7c0,3.866 -3.134,7 -7,7z",
    fill: "#66bb6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,17h-7v-14h7c3.866,0 7,3.134 7,7v0c0,3.866 -3.134,7 -7,7z",
    fill: "#ff7043"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 7,
    fill: "#29b6f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Figma);
export default __webpack_public_path__ + "static/media/icons8-figma.a16429e681b9cbe579c3e233bdfbb844.svg";
export { ForwardRef as ReactComponent };